<form class="column gap" [formGroup]="grantForm">
  <mat-toolbar class="center">
    <div class="row gap">
      <h5 *ngIf="!grant" class="top-bar-view-title">{{ 'CreateGrantComponent.createGrant' | translate }}</h5>
      <h5 *ngIf="grant" class="top-bar-view-title">{{ 'CreateGrantComponent.infoGrant' | translate }}</h5>
    </div>
  </mat-toolbar>
  <div class="column gap-lg modal__inputs">
    <mat-form-field floatLabel="always">
      <mat-label>
        {{ 'CreateGrantComponent.name' | translate }}
      </mat-label>
      <input matInput placeholder="{{ 'CreateGrantComponent.grantName' | translate }}"
             type="text" formControlName="name" />
    </mat-form-field>
    <mat-form-field floatLabel="always">
      <mat-label>
        {{ 'CreateGrantComponent.percentage' | translate }}
      </mat-label>
      <input matInput placeholder="{{ 'CreateGrantComponent.percentage' | translate }}"
             type="number" min="1" max="100" formControlName="percentage" />
    </mat-form-field>
    <mat-form-field floatLabel="always" (click)="startDatePicker.open()">
      <mat-label>
        {{ 'CreateGrantComponent.since' | translate }}
      </mat-label>
      <input matInput placeholder="{{ 'CreateGrantComponent.since' | translate }}"
             formControlName="startDate" [matDatepicker]="startDatePicker" readonly>
      <mat-datepicker-toggle matIconSuffix [for]="startDatePicker"></mat-datepicker-toggle>
      <mat-datepicker #startDatePicker></mat-datepicker>
    </mat-form-field>
    <mat-form-field floatLabel="always" (click)="endDatePicker.open()">
      <mat-label>
        {{ 'CreateGrantComponent.until' | translate }}
      </mat-label>
      <input matInput placeholder="{{ 'CreateGrantComponent.until' | translate }}"
             formControlName="endDate" [matDatepicker]="endDatePicker" readonly>
      <mat-datepicker-toggle matIconSuffix [for]="endDatePicker"></mat-datepicker-toggle>
      <mat-datepicker #endDatePicker></mat-datepicker>
    </mat-form-field>
    <mat-error *ngIf="grantForm.hasError('dateInterval')">
      {{ 'Common.startingDateOlderThanEndingDateError' | translate }}
    </mat-error>
    <mat-form-field floatLabel="always">
      <mat-label>
        {{ 'CreateGrantComponent.campaings' | translate }}
      </mat-label>
      <mat-select formControlName="campaings" multiple>
        <mat-option *ngFor="let campaing of campaings" [value]="campaing">{{campaing}}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field floatLabel="always">
      <mat-label>
        {{ 'CreateGrantComponent.type' | translate }}
      </mat-label>
      <mat-select formControlName="typeEuroinnovaIds" multiple>
        <mat-option *ngFor="let type of courseTypes" [value]="type.euroinnovaId">{{ type.label }}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field floatLabel="always">
      <mat-label>
        {{ 'CreateGrantComponent.faculty' | translate }}
      </mat-label>
      <mat-select formControlName="faculties" multiple>
        <mat-option *ngFor="let faculty of facultyList" [value]="faculty.euroinnovaId">{{ faculty.label }}</mat-option>
      </mat-select>
    </mat-form-field>
    <div *ngIf="!grant" class="row horizontal-end">
      <button class="modal__button" mat-raised-button color="primary" [disabled]="grantForm.invalid" (click)="createGrant()">
        {{ 'CreateGrantComponent.createGrant' | translate }}
      </button>
    </div>
    <div *ngIf="grant" class="row horizontal-end gap">
      <button class="modal__button" mat-raised-button color="primary" [disabled]="grantForm.invalid" (click)="editGrant()">
        {{ 'CreateGrantComponent.modify' | translate }}
      </button>
      <button class="modal__button" mat-raised-button color="secondary" (click)="closeDialog()">
        {{ 'CreateGrantComponent.cancel' | translate }}
      </button>
    </div>
  </div>
</form>
